import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_course_bill",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "course_bill",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_course_bill_button",
  "data-kt-drawer-close": "#kt_drawer_course_bill_close",
  "data-kt-drawer-width": "75.5vw"
}
const _hoisted_2 = {
  id: "kt_course_bill",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_course_bill_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Edit Course Bill </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_course_bill_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_course_bill_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_course_bill_body",
  "data-kt-scroll-dependencies": "#kt_course_bill_header, #kt_course_bill_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card-body p-2" }
const _hoisted_7 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_course_bill_scroll"
}
const _hoisted_8 = { class: "card mb-5 mb-xl-10 p-5" }
const _hoisted_9 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_bill_configuration",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, " Course Bill Configuration ")
], -1)
const _hoisted_11 = { class: "card-title m-0" }
const _hoisted_12 = { class: "col-md-1" }
const _hoisted_13 = { class: "form-label d-flex" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Contribution Percentage", -1)
const _hoisted_15 = {
  key: 0,
  class: "badge badge-warning"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-warning"
}
const _hoisted_17 = {
  id: "course_bill_configuration",
  class: "collapse show"
}
const _hoisted_18 = { class: "collapse show" }
const _hoisted_19 = { class: "card-body border-top p-5" }
const _hoisted_20 = { "data-kt-stepper-element": "content" }
const _hoisted_21 = { class: "row mt-2" }
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Claim", -1)
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Milestone ", -1)
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", {
  value: "1",
  label: "Enrollment"
}, "Enrollment", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", {
  value: "2",
  label: "Certification"
}, "Certification", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "3",
  label: "Employement"
}, "Employement", -1)
const _hoisted_30 = [
  _hoisted_27,
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = { class: "col-md-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Claim%", -1)
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Advance Adjustment %", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-1" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "badge badge-primary" }, "Claim Cost")
  ])
], -1)
const _hoisted_36 = { class: "col-md-1" }
const _hoisted_37 = { class: "form-label" }
const _hoisted_38 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_39 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_40 = {
  class: "py-5 text-center",
  id: "kt_course_bill_footer"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_course_bill_cancel",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_42 = ["data-kt-indicator"]
const _hoisted_43 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_44 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_45 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.rules,
            ref: "formRef",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, [
                            _hoisted_14,
                            (this.percentageInfo)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(this.percentageInfo) + "% ", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, " 0% "))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.bills, (v, i) => {
                              return (_openBlock(), _createElementBlock("div", { key: i }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createVNode(_component_Field, {
                                      modelValue: v.x_claim_milestone_id,
                                      "onUpdate:modelValue": ($event: any) => ((v.x_claim_milestone_id) = $event),
                                      type: "string",
                                      class: "form-control form-control-sm",
                                      disabled: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _hoisted_25,
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-select-solid",
                                      filterable: "",
                                      style: {"width":"100%"},
                                      placeholder: "Select Training Milestone",
                                      "onUpdate:modelValue": ($event: any) => ((v.x_training_milestone_id) = $event),
                                      disabled: ""
                                    }, _hoisted_30, 8, _hoisted_26), [
                                      [_vModelSelect, v.x_training_milestone_id]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _hoisted_32,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: v.claim_percentage,
                                      "onUpdate:modelValue": ($event: any) => ((v.claim_percentage) = $event),
                                      class: "form-control form-control-sm"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _hoisted_34,
                                    _createVNode(_component_Field, {
                                      type: "number",
                                      modelValue: v.adj_adv_reduction_perc,
                                      "onUpdate:modelValue": ($event: any) => ((v.adj_adv_reduction_perc) = $event),
                                      class: "form-control form-control-sm"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _hoisted_35,
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("label", _hoisted_37, [
                                      (v.claim_percentage)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(this.unit_cost_total *
                                      (v.claim_percentage / 100)), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_39, " 00 "))
                                    ])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.load]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_44, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_46
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_42)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}